// PageHeader Task Component

import React from 'react'

import PageHeader from '../page_header/page_header.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Util from '../../../lib/util.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class PageHeaderTime extends PageHeader {
  constructor (props) {
    super(props)

    this.disableAutoOpenFilter()
    this.data.currentPanel = 'main'
  }

  _renderTitleInfo () {
    const {
      title,
      subtitle,
      icon,
      isTitleMultilingual,
      userName,
      isDefaultUser,
      canChangeUser,
      isOverDue,
      openHours,
      totalHours
    } = this.props

    return (
      <div className='layoutrow'>
        <div className='layoutcolfull'>
          <div className='titleinfo layoutrow'>
            <div className='menu-icon'>
              {icon}
            </div>
            <div className='title layoutcolfull'>
              <h1>
                {isTitleMultilingual ? <IntlMessage ident={title} /> : title}
                <span
                  className={`userinfo${isDefaultUser ? ' default' : ''}`}
                  onClick={
                    canChangeUser
                      ? this._onSelectFilter.bind(this, 'member')
                      : null
                  }
                >
                  &nbsp;
                  <IntlMessage ident='task.list.labelAs' />
                  &nbsp;
                  {userName}
                </span>
              </h1>
              {subtitle && (
                <div className='subtitle'>
                  {isTitleMultilingual ? (
                    <IntlMessage ident={subtitle} />
                  ) : (
                    subtitle
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='layoutcol'>
          <div className='textinfos'>
            <div className='item'>
              <span className={isOverDue ? 'overdue' : 'active'}>
                {openHours
                  ? Util.convertMinutesToTimeText(openHours)
                  : IntlUtil.convertMessage('time.list.defaultHours')}
              </span>
            </div>
            <div className='item subtitle'>
              {!isOverDue ? (
                Util.convertMinutesToTimeText(totalHours)
              ) : (
                <>
                  <span>{Util.convertMinutesToTimeText(-1 * totalHours)} </span>
                  <IntlMessage ident='time.list.overdueLabel' />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onSaveTag () {
    if (!this.data.keywordTag) {
      this._onSelectTag(null)
    }

    this._onChangeFilterPanel('main')
  }
}

export default PageHeaderTime
